import React from "react";
import { PRATICA, RTL, IMG } from "@/content/site";
import { Container, Eyebrow, Reveal } from "@/components/site/ui";

// Experiência e prática + RTL Amazônia, num único bloco discreto.
export const Pratica = () => (
    <section data-testid="home-pratica" data-section-id="pratica" className="relative bg-[#0A1812] py-24 md:py-32 overflow-hidden">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
            <Reveal className="lg:col-span-6">
                <Eyebrow>{PRATICA.eyebrow}</Eyebrow>
                <p className="font-serif font-light text-[22px] md:text-[27px] leading-[1.5] text-[#F2EFE5] max-w-xl">{PRATICA.text}</p>
                <div data-testid="home-rtl" data-section-id="rtl" className="mt-14 pt-8 border-t border-[#1B3025] max-w-xl">
                    <p className="font-sans text-[10px] uppercase tracking-[0.28em] text-[#7E8978]">{RTL.eyebrow}</p>
                    <p className="mt-3 font-sans font-light text-[14px] leading-[1.75] text-[#B0B6A6]">{RTL.text}</p>
                    <a href={RTL.url} target="_blank" rel="noopener noreferrer" data-testid="home-rtl-link" className="mt-6 inline-flex items-center gap-3 rounded-full border border-[#C7A659]/60 text-[#C7A659] px-6 py-3 font-sans text-[11px] uppercase tracking-[0.2em] hover:bg-[#C7A659] hover:text-[#0A1812] transition-colors">
                        {RTL.cta} <span aria-hidden="true">↗</span>
                    </a>
                </div>
            </Reveal>
            <Reveal className="lg:col-span-6" delay={150}>
                <div className="relative aspect-[5/4] lg:aspect-[4/5] overflow-hidden rounded-sm">
                    <img src={IMG.pratica} alt="Pessoas reunidas em torno de uma banca de comércio de rua" loading="lazy" className="absolute inset-0 w-full h-full object-cover" style={{ filter: "saturate(0.8) contrast(1.05)" }} />
                    <div aria-hidden="true" className="absolute inset-0 bg-[#0E2018]/20" />
                </div>
            </Reveal>
        </Container>
    </section>
);
